import { useTranslation } from "react-i18next";
import Cards from "./cards";
import SalesTrends from "./salesTrends";
import MemberGrowth from "./memberGrowth";
import MembersDistribution from "./membersDistibution";
import ActivityParticipation from "./activityParticipation";
import MembersDetailsTable from "./membersDetailsTypeTable";
import DateSearchInput from "../../components/inputs/dateSearchInput";
import SearchSelect from "../../components/select/searchSelect";
import { useOptions } from "../../components/hooks/useOptionsHook";
import { useFormik } from "formik";

const Reports = () => {
  const { t } = useTranslation();
  const { memberShipTypeOptions } = useOptions();
  const formik = useFormik({
    initialValues: {},
    onSubmit: (vals) => {
      console.log(vals);
    },
  });
  return (
    <main>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold capitalize text-primary">{t("reports")}</h1>
        <div className="flex items-center gap-1">
          <DateSearchInput
            placeholder={t("startDate")}
            formik={formik}
            name={"start"}
          />
          <DateSearchInput placeholder={t("endDate")} formik={formik} name={"end"} />
          <div>
            <SearchSelect
              options={memberShipTypeOptions}
              formik={formik}
              name={"download"}
              placeholder={t("downloadFile")}
            />
          </div>
        </div>
      </div>
      <article className="space-y-3">
        <Cards t={t} />
        <div className="flex flex-col gap-4 lg:flex-row">
          <SalesTrends t={t} />
          <MemberGrowth t={t} />
        </div>
        <div className="flex flex-col gap-4 lg:flex-row">
          <MembersDistribution t={t} />
          <ActivityParticipation t={t} />
        </div>
        <div className="py-6 mainLinear px-7 rounded-2xl ">
          <h2 className="my-3 font-semibold text-primary">{t("memberDetailsType")}</h2>
          <MembersDetailsTable t={t} />
        </div>
      </article>
    </main>
  );
};

export default Reports;
